import { render, staticRenderFns } from "./bindCard.vue?vue&type=template&id=463f3984&scoped=true&"
import script from "./bindCard.vue?vue&type=script&lang=js&"
export * from "./bindCard.vue?vue&type=script&lang=js&"
import style0 from "./bindCard.vue?vue&type=style&index=0&id=463f3984&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463f3984",
  null
  
)

export default component.exports